import styled from "@mui/material/styles/styled";

import { BaseHeaderContainer } from "@app/analytics/components/reports/styles";

export const MeetingReportHeaderContainer = styled(BaseHeaderContainer)(
  ({ theme }) => ({
    height: "60px",
    [theme.breakpoints.up("mobile")]: {
      height: "72px",
    },
    [theme.breakpoints.down("mobile")]: {
      "& .meeting-report__header__tags, .meeting-report__header__participants":
        {
          display: "none",
        },
      borderBottom: "1px solid",
      borderTop: "1px solid",
      borderColor: theme.palette.shades.neutral[100],
    },
  })
);
